import { unref } from "vue";

// Light / dark theme choice, kept per device in localStorage so it also works without an account.
// "system" follows the device setting (prefers-color-scheme).
const STORAGE_KEY = "qwwThemePreference";
export const THEME_PREFERENCES = ["light", "dark", "system"];
export const DEFAULT_THEME_PREFERENCE = "light";

export function getStoredThemePreference() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return THEME_PREFERENCES.includes(stored) ? stored : DEFAULT_THEME_PREFERENCE;
  } catch {
    return DEFAULT_THEME_PREFERENCE;
  }
}

// theme: the Vuetify theme instance (useTheme() or this.$vuetify.theme)
export function setThemePreference(theme, preference) {
  if (!THEME_PREFERENCES.includes(preference)) {
    return;
  }
  theme.change(preference);
  try {
    window.localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    // Private mode or blocked storage: the choice only lasts for this visit
  }
}

// Current choice of the Vuetify theme instance ("system" when it follows the device)
export function getThemePreference(theme) {
  return unref(theme.isSystem) ? "system" : unref(theme.name);
}
